module.exports = __webpack_public_path__ + "img/companies.8a7023c8.svg";